var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 33.871,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.0166667) scale(0.0192308 0.0198718)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 52,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABmJLR0QA/wD/AP+gvaeTAAADOklEQVRYCe1ZzWsTQRTf3XyQj+qpAYkhIV5CEWokJSeRFBQPevYkYj1VPHnxoJ4E9T/QHlIVvPgXeNCCiGhbDHpQ0UAQ8gkh60VNDSHZ+Juwu0423U0JnUmMU97LvDcz+977vfey3cxKkvgTGRAZEBmY5QzIewUXi8WO93q9i7Isn8I1h8DzYJakwngdPl9omvawUql8hD6SRgIKhUJzfr8/CyDnYW3kfuxhQRr8Z9vt9rVarbbj5MAxwHA4HPB4PK9gYAk8DZRrtVqZer3etAtGsVsg816v9wHGaQGDUKQldMt9ItixbLcQj8fT6N0trNN7PkO/3ul0tqvV6nfIzAjdMY/uSMPBbXAKbFAPcaXL5XLOmKBHN63QcrfbXZHxR8299/l8mXw+/5OaYybiu6LC+LNIJPLS5XJtQj4GJiQrinJJkqQceIiUoRl9AliWdbE/QL/BC0zfof6Bu9tviDfBNA3ERi/YAsKmw2CTms3mG1PhLKD1XltcRiy6qToBmjN3QWg0Gr8wTIQKhcIPi+ODFt1UnQCZm/4lYeYA2d7l9rMqqVTKg5ZdJDZxy/+CO9gOkVkw8wrhGXBBVdW3uEvmCLvd7gUWQAybzCpEgADAKh4ur8CZB8yFmAACmA+IPgkwGPgSq5ZL8oXx1xsrQIaHrxAegbkRK0B38Lx1plgsHkXbkQdcboCYfIcA5BY3BBZHrCpkccNPFYD45Xo8T6JC4+WN31WiQvxyPZ4nUaHx8sbvqpmrEJNHH7oeOH19ijPpDWMOetWQWYzMAeknNtZTGxZY+jZnruWcADX7kPUP8lpFF7kPiUTigMWp7RmhE6ASbSQYDJ6gdZ4yXqGctPgbiI1eU2jFIm/QOn6o3UsMZ4rewkTWO+MubRyHLwOx0WtOgMhP5x61OYlMbeIA5KzuhFraf5EkLxqNngsEAtuw3j/Tw0hIA6B1IuzG8m6TxhyCfwL5AnhqCJ3yuFQqrdgF5FQhCRVZRTbe2V08gfktnLxedfLrCIi8y8Q/xYwkSVmwBp4UaajMGpK7POoYWd5rhHhFuQijl8Gncc0RsA/Mklow/g3+noPX8QryE3RBIgMiAyID/3kG/gDmXN3AI3qI2AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.2bce4096a6d40052c27542b05bb667e6.svg";
export { ForwardRef as ReactComponent };